import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IUserStore {
	userData: {
		userId?: string;
		userEmail?: string;
	};
}

const initialState: IUserStore = {
	userData: {
		userId: undefined,
		userEmail: undefined,
	},
};

const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		setUserData: (state, action: PayloadAction<IUserStore["userData"]>) => {
			state.userData = action.payload;
		},

		resetUserState: () => initialState,
	},
});

export const { setUserData, resetUserState } = userSlice.actions;

export default userSlice.reducer;
